import { Field } from "formik";
import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next"; /* Added Line */
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  addActiveFn,
  withNewTitleAndName,
  requestTo,
} from "../../components/action-buttons/ActionButtonGenerator";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import {
  formatListWithParameter,
  formatShortDate,
  truncateText,
  formatFileTypeList,
} from "../../utils";
import { Accordion, Button, Card } from "react-bootstrap";
import Filters from "../../components/list/Filters";
import ReactDatePicker from "../../components/form-fields/ReactDatePicker";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import request from "../../services/request";
import DocumentUpdate from "./document-update/DocumentUpdate";
import { ThemeContext } from '../../../context/ThemeContext';
import DemandUpdate from "./demand-update/DemandUpdate";


export default function Assigned(props) {
  const { changeSpinnerStatus } = useContext(ThemeContext);
  const [refreshList, setRefreshList] = useState(false);
  const [t] = useTranslation(); /* Added Line */
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("");
  const [filters, setFilters] = useState([]);
  const [configData, setConfigData] = useState(null);
  const [companies, setCompanies] = useState([]);
  const onGroupChanged = (groupIds) => {
    getCompanies(groupIds);
  };
  const [talepTurleri, setTalepTurleri] = useState([]);
  const [dosyaTurleri, setDosyaTurleri] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [returnReason, setReturnReason] = useState("");

  const ikiliFormat = new URLSearchParams(props.location.search).get(
    "ikiliFormat"
  );

  const getCompanies = (companyGroupIds, yurtBilgi) => {
    request({
      url: "company/multi-company",
      method: "POST",
      data: {
        body: {
          companyGroupIds: [companyGroupIds],
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setCompanies(response.body.tableData);
      }
    });
  };

  const onUpdateButtonClicked = (selectedRow) => {
    //selectedRow.disableButton = true;
    setSelectedRow(selectedRow);
    setShowModal(true);
    setIsUpdating(true);
  };

  const onViewButtonClicked = (selectedRow) => {
    selectedRow.disableButton = true;
    setSelectedRow(selectedRow);
    setShowModal(true);
    setIsUpdating(true);
  };
  const onDepartmentChanged = (departmanId) => {
    request({
      url: "dosya-durum/config",
      method: "POST",
      data: {
        body: {
          id: departmanId,
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setTalepTurleri(response.body.talepTur);
      }
    });
  };

  const onReject = () => {
    request({
      url: "atanan-talep/iade-et",
      method: "POST",
      data: {
        body: {
          id: selectedRow.id,
          iadeNedeni: returnReason,
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setRefreshList(!refreshList);
        setShowModal(false);
      }
    });
  };

  const onTalepChanged = (talepId) => {
    request({
      url: "dosya-tur/multi-talepTur-config-dosyaTur",
      method: "POST",
      data: {
        body: {
          companyGroupIds: talepId ? [talepId] : [],
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setDosyaTurleri(response.body.tableData);
      }
    });
  };
  const linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Button className="btn-xs"
        onClick={() => {
          onUpdateButtonClicked(row);
        }}
      >
        <i className="fa fa-search color-white"></i>
      </Button>
    );
  };

  return (
    <Main>
      <div className={"row"}>
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="0"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                  } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="raporlar/config"
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                  >
                    <Field
                      name="yurtici"
                      label={t("demandList.yurtici")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.yurtici}
                    />
                    <Field
                      name="sirketDurumu"
                      label={t("demandList.sirketDurumu")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.sirketDurumu}
                    />
                    <Field
                      name="isSubsidiary"
                      label={t("demandList.istirakSirketleri")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.isSubsidiary}
                    />
                    <Field
                      name="groupID"
                      label={t("davaIcraSavcilik.grup")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.grupSirketleri}
                      onChangeFunc={(opt) => onGroupChanged(opt)}
                    />
                    <Field
                      name="sirketID"
                      label={t("davaIcraSavcilik.grupSirketi")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={
                        companies.length > 0
                          ? companies.map((c) => {
                            return { value: c.id, label: c.name };
                          })
                          : configData && configData.sirketler
                      }
                    />

                    <Field
                      name="islemNo"
                      label={t("davaIcraSavcilik.islemNo")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="dosyaNo"
                      label={t("documentUpdate.dosyaNo")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="departmanID"
                      label={t("documentTypes.departman")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.departmanlar}
                      onChangeFunc={(opt) => onDepartmentChanged(opt)}
                    />
                    <Field
                      name="talepTuruID"
                      label={t("demandTypes.talepTürü")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={
                        talepTurleri.length > 0
                          ? talepTurleri
                          : configData && configData.talepTurleri
                      }
                      onChangeFunc={(opt) => onTalepChanged(opt)}
                    />
                    <Field
                      name="dosyaTuru"
                      label={t("davaIcraSavcilik.dosyaTuru")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={
                        dosyaTurleri.length > 0
                          ? dosyaTurleri.map((dt) => {
                            return { value: dt.id, label: dt.dosyaTuru };
                          })
                          : configData && configData.dosyaTurleri
                      }
                    />

                    <Field
                      name="talepDurumuID"
                      label={t("demandStates.talepDurumu")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.talepDurumu}
                    />

                    <Field
                      name="avukatID"
                      label={t("report.gorevlendirilen")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.users}
                    />
                    <Field
                      name="gorevlendirilenDisAvukatId"
                      label={t("demandList.gorevliAvukat")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.disAvukatlar}
                    />
                    <Field
                      name="konu"
                      label={t("davaIcraSavcilik.konu")}
                      colNumber="3"
                      component={TextInput}
                    />

                    <Field
                      name="acilisTarihiMin"
                      label={t("demandList.baslangicTarihi")}
                      colNumber="3"
                      component={ReactDatePicker}
                    />
                    {/* <Field
                      name="acilisTarihiMax"
                      label={t("demandList.bitisTarihi")}
                      colNumber="3"
                      component={ReactDatePicker}
                    /> */}
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      {(selectedRow?.talepDurumId === 1 || selectedRow?.talepDurumId === 5) && (
        // PendingDemands sayfasından alındı
        <DemandUpdate
          extraButton
          extraButtonOnClick={onReject}
          pageType={1}
          extraButtonText={t("actionButtonGenerator.red")}
          type={1}
          title={t("anaSayfa.bekleyenTalepler")}
          endpoint={"yonlendirilecek-talep/avukatAta"}
          okButtonText={t("actionButtonGenerator.atamaYap")}
          refreshList={refreshList}
          setRefreshList={setRefreshList}
          showModal={showModal}
          isUpdating={isUpdating}
          selectedRow={selectedRow}
          setShowModal={setShowModal}
          setRejectReason={setRejectReason}
        />
      )}
      {(selectedRow?.talepDurumId === 2) && (
        // DirectedDemands sayfasından alındı
        <DemandUpdate
          extraButton
          extraButtonOnClick={onReject}
          pageType={1}
          extraButtonText={t("actionButtonGenerator.iadeEt")}
          type={3}
          title={t("anaSayfa.yonlendirilmisTalepler")}
          endpoint={"atanan-talep/dosyaya-donustur"}
          endPointUrl2={"atanan-talep/tamamla"}
          endPointUrl3={"atanan-talep/kaydet"}
          endPointUrl4={"atanan-talep/baslat"}
          okButtonText={t(
            selectedRow?.talepTur?.departmentId == 2
              ? "actionButtonGenerator.dosyayaDonustur"
              : "actionButtonGenerator.numaraVer"
          )}
          secondSubmitButttonText={t(
            selectedRow?.talepTur?.departmentId == 2
              ? "actionButtonGenerator.tamamla"
              : "actionButtonGenerator.numaraVermeden"
          )}
          thirdSubmitButttonText={t("actionButtonGenerator.taslak")}
          fourthSubmitButttonText={t("actionButtonGenerator.baslat")}
          refreshList={refreshList}
          setRefreshList={setRefreshList}
          showModal={showModal}
          isUpdating={isUpdating}
          selectedRow={selectedRow}
          setShowModal={setShowModal}
          setReturnReason={setReturnReason}
        />
      )}
      {(selectedRow?.talepDurumId === 3) && (
        // ContinuingDemands sayfasından alındı
        <DemandUpdate
          extraButton
          extraButtonOnClick={onReject}
          extraButtonText={t("actionButtonGenerator.iadeEt")}
          pageType={2}
          type={2}
          title={(surecDevamEdiyor) ? t("anaSayfa.sureciDevamEdenTalepler") : t("anaSayfa.surecDevamEdenTalepler")}
          endpoint={"atanan-talep/dosyaya-donustur"}
          endPointUrl2={"atanan-talep/tamamla"}
          endPointUrl3={"atanan-talep/kaydet"}
          okButtonText={t(
            selectedRow?.talepTur?.departmentId == 2
              ? "actionButtonGenerator.dosyayaDonustur"
              : "actionButtonGenerator.numaraVer"
          )}
          secondSubmitButttonText={t(
            selectedRow?.talepTur?.departmentId == 2
              ? "actionButtonGenerator.tamamla"
              : "actionButtonGenerator.numaraVermeden"
          )}
          thirdSubmitButttonText={t("actionButtonGenerator.taslak")}
          refreshList={refreshList}
          setRefreshList={setRefreshList}
          showModal={showModal}
          isUpdating={isUpdating}
          selectedRow={selectedRow}
          setShowModal={setShowModal}
          setReturnReason={setReturnReason}
        />
      )}
      {(selectedRow?.talepDurumId === 4) && (
        // dosya açıldı
        <DocumentUpdate
          title={selectedRow?.talepDurumName}
          endpoint={"dosya/guncelle"}
          okButtonText={t("actionButtonGenerator.kaydet")}
          refreshList={refreshList}
          setRefreshList={setRefreshList}
          showModal={showModal}
          isUpdating={isUpdating}
          selectedRow={selectedRow}
          setShowModal={setShowModal}
        />
      )}
      {(selectedRow?.talepDurumId === 6) && (
        // Completed sayfasından alındı
        <DocumentUpdate
          title={t("anaSayfa.tamamlananlar")}
          endpoint={"dosya/guncelle"}
          okButtonText={t("actionButtonGenerator.kaydet")}
          refreshList={refreshList}
          setRefreshList={setRefreshList}
          showModal={showModal}
          isUpdating={isUpdating}
          selectedRow={selectedRow}
          setShowModal={setShowModal}
        />
      )}
      {(selectedRow?.talepDurumId === 7) && (
        // Rejected sayfasından alındı
        <DocumentUpdate
          title={t("anaSayfa.reddedilenler")}
          endpoint={"dosya/guncelle"}
          okButtonText={t("actionButtonGenerator.kaydet")}
          refreshList={refreshList}
          setRefreshList={setRefreshList}
          showModal={showModal}
          isUpdating={isUpdating}
          selectedRow={selectedRow}
          setShowModal={setShowModal}
        />
      )}
      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName=""
            endpoint={
              ikiliFormat
                ? "atanan-talep/listele-atanan-tumu"
                : "atanan-talep/listele-atanan"
            }
            hideSelection={true}
            keyField="id"
            refreshList={refreshList}
            customBody={{
              filters: filters,
            }}
            columns={[
              {
                dataField: "id",
                text: `${t("demandList.islemNo")}`,
                sort: true,
                headerStyle: {
                  width: 64,
                },
              },
              // {
              //   dataField: "dosya[0].dosyaNo",
              //   text: `${t("demandList.golgeDNo")}`,
              //   sort: true,
              //   headerStyle: {
              //     width: 64
              //   }
              // },
              {
                dataField: "companyGroup",
                text: `${t("demandList.grup")}`,
                formatter: (data) => formatListWithParameter(data, "name"),
                sort: true,
              },
              {
                dataField: "company.name",
                text: `${t("demandList.grupSirketi")}`,
                formatter: (data) => truncateText(data, 50, 40),
                sort: true,
              },
              {
                dataField: "talepTur.departman.name",
                text: `${t("demandList.departman")}`,
                sort: true,
              },
              {
                dataField: "avukat.fullName",
                text: `${t("report.gorevlendirilen")}`,
                sort: true,
              },
              {
                dataField: "talepTur.talepTuru",
                text: `${t("demandList.talepTuru")}`,
                sort: true,
              },
              {
                dataField: "dosyaTuruList",
                text: `${t("demandList.dosyaTuru")}`,
                formatter: (data) => formatFileTypeList(data, "dosyaTuru"),
                sort: true,
              },
              {
                dataField: "talepDurum.talepDurumName",
                text: `${t("demandList.talepDurumu")}`,
                sort: true,
              },
              /*{
                                dataField: "sonDurumu",
                                text: "Son Durumu",
                                sort: true,
                            },*/
              {
                dataField: "sonDurum.mesaj",
                text: `${t("demandList.sonDurum")}`,
                formatter: (data) => truncateText(data, 35, 30),
                sort: true,
                headerStyle: {
                  width: 120,
                },
              },
              {
                dataField: "konu",
                text: `${t("demandList.konu")}`,
                formatter: (data) => truncateText(data, 35, 30),
                sort: true,
              },
              {
                dataField: "createdUser.fullName",
                text: `${t("demandList.ekleyen")}`,
                sort: true,
              },
              {
                dataField: "cdate",
                text: `${t("demandList.talepTarihi")}`,
                formatter: formatShortDate,
                sort: true,
                headerStyle: {
                  width: 80,
                },
              },
              // {
              //   dataField: "dosya[0].baslangicTarihi",
              //   text: `${t("demandList.baslangicTarihi")}`,
              //   formatter: formatShortDate,
              //   sort: true,
              // },
              {
                dataField: "dosya[0].bitisTarihi",
                text: `${t("demandList.tamamlamaTarhihi")}`,
                formatter: formatShortDate,
                sort: true,
              },
              // {
              //   dataField: "isGucuBirimi.name",
              //   text: `${t("demandList.isGücüBirim")}`,
              //   sort: true,
              // },
              {
                dataField: "bedel",
                text: `${t("demandList.bedel")}`,
                sort: true,
              },
              {
                dataField: "gnlTpDil.name",
                text: `${t("demandList.dil")}`,
                sort: true,
              }, {
                dataField: "",
                text: "İşlemler",
                formatter: linkFollow,
                sort: false,
              },
            ]}
            actionButtonsObject={{
              actions: [
                pushToParams(ABT.EXCEL_EXPORT, {
                  requestTo: ikiliFormat
                    ? "file/download-excel-atanan-tumu"
                    : "file/download-excel-atanan",
                }),
                addActiveFn(
                  pushToParams(
                    withNewTitleAndName(
                      ABT.EDIT,
                      "actionButtonGenerator.goruntule",
                      "EDIT_WITH_TITLE"
                    ),
                    onViewButtonClicked
                  ),
                  (row) => !row.departmanYoneticisiMi
                ),
                addActiveFn(
                  pushToParams(ABT.EDIT, onUpdateButtonClicked),
                  (row) => row.departmanYoneticisiMi
                ),
                //pushToParams(ABT.EDIT, onUpdateButtonClicked),
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}
